"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SliderFlickity = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_flickity_component_1 = __importDefault(require("react-flickity-component"));
const react_1 = require("react");
const defaultOptions = {
    accessibility: false,
    autoPlay: false,
    cellAlign: 'left',
    contain: true,
    draggable: true,
    dragThreshold: 5,
    freeScroll: true,
    freeScrollFriction: 0.075,
    friction: 0.15,
    groupCells: false,
    initialIndex: 0,
    lazyLoad: 2,
    pauseAutoPlayOnHover: false,
    prevNextButtons: false,
    pageDots: false,
    resize: true,
    selectedAttraction: 0.01,
    wrapAround: false
};
//   // just in case the dragEnd event doesn't fire:
//   document.body.addEventListener('touchstart', (ev) => {
//     document.ontouchmove = () => true;
//   });
// }
const sliderBeingDragged = 'slider-being-dragged';
function dragEnd() {
    document.ontouchmove = () => true;
    setTimeout(() => {
        document.body.classList.remove(sliderBeingDragged);
    }, 50);
}
function dragMove() {
    document.ontouchmove = () => false;
    document.body.classList.add(sliderBeingDragged);
}
function dragStart() {
    document.ontouchmove = () => false;
}
exports.SliderFlickity = (0, react_1.memo)(({ children, className = '', elementType = 'div', options = {}, onChange = null, reloadOnUpdate = false, dynamicSlider = false }) => {
    const [flickityRef, setFlickityRef] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        if (!flickityRef)
            return;
        flickityRef.on('dragStart', dragStart);
        flickityRef.on('dragMove', dragMove);
        flickityRef.on('dragEnd', dragEnd);
        if (onChange)
            flickityRef.on('change', onChange);
        return () => {
            flickityRef.off('dragStart', dragStart);
            flickityRef.off('dragMove', dragMove);
            flickityRef.off('dragEnd', dragEnd);
            if (onChange)
                flickityRef.off('change', onChange);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [flickityRef]);
    return ((0, jsx_runtime_1.jsx)(react_flickity_component_1.default, Object.assign({ flickityRef: (ref) => setFlickityRef(ref), className: `slider ${className}`, elementType: elementType, options: Object.assign(Object.assign({}, defaultOptions), options), disableImagesLoaded: false, reloadOnUpdate: reloadOnUpdate, static: !dynamicSlider }, { children: children })));
});
